import { PlusCircleOutlined } from '@ant-design/icons'
import type { UploadProps } from 'antd'
import { Upload } from 'antd'
import React from 'react'
import { Chain } from 'wagmi'
import { ErrorFile } from './ErrorFile'
import { FileContent } from './FileContent'
import { useFileUpload } from '../hooks/useFileUpload'

const { Dragger } = Upload

const props: UploadProps = {
  name: 'file',
  onDrop(e) {
    // eslint-disable-next-line no-console
    console.log('Dropped files', e)
  },
}

export const FileUpload = ({
  chain,
  tokenInfo,
}: {
  chain: Chain
  tokenInfo: any
}) => {
  const { error, setError, transferData, beforeUpload, toggleFile } = useFileUpload()
  if (error) {
    return <ErrorFile network={chain.network} resetError={setError} />
  }
  return (
    <div>
      {!transferData ? (
        <Dragger
          {...props}
          style={{ backgroundColor: 'white', border: 'none' }}
          beforeUpload={beforeUpload}
        >
          <p className="ant-upload-drag-icon">
            <PlusCircleOutlined style={{ fontSize: 70 }} />
          </p>
          <p className="ant-upload-text">
            Click or drag file with validators to upload
          </p>
          <p className="ant-upload-hint">
            Upload file with information about validators you want to create for
            selected network
          </p>
        </Dragger>
      ) : (
        <FileContent
          fileContent={transferData}
          tokenInfo={tokenInfo}
          uploadNewFile={() => toggleFile(null)}
        />
      )}
    </div>
  )
}
